/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Folder_folderPortfolioItems$ref = any;
export type Folder_folderPortfolioItems = ReadonlyArray<{
    readonly __typename: "PortfolioItemV2";
    readonly " $refType": Folder_folderPortfolioItems$ref;
} & ({
    readonly __typename: "PortfolioItemV2";
} | {
    /*This will never be '% other', but we need some
    value in case none of the concrete values match.*/
    readonly __typename: "%other";
})>;



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "Folder_folderPortfolioItems",
    "type": "PortfolioItemV2",
    "metadata": {
        "plural": true
    },
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'da196c25d5f0eb1a44e37c24aca70d52';
export default node;
